"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTemplateSurface = void 0;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const Template_1 = require("../../models/Template");
const numbers_1 = require("../../helpers/numbers");
/**
 * Gets surface off the template. It's not as simple as template.surface,
 * because we're moving to a surfaces array instead of 1 default surface.
 *
 * We're moving towards all templates having "surfaces" so that there is a
 * consistent way that products can have multiple surfaces. Until then, if
 * a template has a "surface" field, we'll use the old logic to get the surface.
 *
 * @param template
 * @param printableGroupType We can have a different surface per printable group type
 * @param interiorPageCount For book covers, your cover surface changes based on page count
 */
const getTemplateSurface = _ref => {
  let {
    template,
    printableGroupType,
    interiorPageCount
  } = _ref;
  if ((0, Template_1.isTemplateOriginal)(template)) {
    return extractLegacyTemplateSurface(template, printableGroupType, interiorPageCount);
  } else if ((0, Template_1.isTemplate2024)(template)) {
    return findTemplateSurfaceForPrintableGroup(template, printableGroupType);
  }
  const message = 'Error: Unable to get surface from unsupported template schema version';
  throw new Error(message);
};
exports.getTemplateSurface = getTemplateSurface;
const extractLegacyTemplateSurface = (template, printableGroupType, interiorPageCount) => {
  var _a, _b, _c;
  if (printableGroupType === 'cover' && template.coverSurfaces) {
    const coverSurface = template.coverSurfaces.find(coverSurf => coverSurf.pageCount && (0, numbers_1.inRange)(interiorPageCount || 0, coverSurf.pageCount.min, coverSurf.pageCount.max));
    if (!coverSurface) {
      const message = 'Unable to find cover surface';
      console.error(message, {
        coverSurfaces: template.coverSurfaces,
        interiorPageCount
      });
      throw new Error(message);
    }
    return (0, lodash_clonedeep_1.default)(coverSurface);
  } else if (printableGroupType === 'wooden-box' && ((_a = template.woodenBox) === null || _a === void 0 ? void 0 : _a.surface)) {
    if (!((_b = template.woodenBox) === null || _b === void 0 ? void 0 : _b.surface)) {
      const message = 'Unable to find wooden-box surface';
      console.error(message, {
        coverSurfaces: template.coverSurfaces,
        interiorPageCount
      });
      throw new Error(message);
    }
    return (0, lodash_clonedeep_1.default)((_c = template.woodenBox) === null || _c === void 0 ? void 0 : _c.surface);
  } else {
    return (0, lodash_clonedeep_1.default)(template.surface);
  }
};
const findTemplateSurfaceForPrintableGroup = (template, printableGroupType) => {
  var _a, _b;
  if (printableGroupType) {
    const printableGroupSurfaces = (_a = template.surfaces) === null || _a === void 0 ? void 0 : _a.filter(surface => !surface.allowedPrintableGroupTypes || surface.allowedPrintableGroupTypes.includes(printableGroupType));
    //TODO: When books are updated to use "surfaces" instead of "surface", cover page count min/max logic will go here
    if ((printableGroupSurfaces === null || printableGroupSurfaces === void 0 ? void 0 : printableGroupSurfaces.length) !== 1) {
      const message = 'Error: No surface found for the given printable group type';
      console.error(message, {
        surfaces: template.surfaces,
        printableGroupType
      });
      throw new Error(message);
    }
    return (0, lodash_clonedeep_1.default)(printableGroupSurfaces[0]);
  }
  if (((_b = template.surfaces) === null || _b === void 0 ? void 0 : _b.length) !== 1) {
    const message = 'Error: Unable to pick a surface without a printable group type';
    console.error(message, {
      surfaces: template.surfaces,
      printableGroupType
    });
    throw new Error(message);
  }
  return (0, lodash_clonedeep_1.default)(template.surfaces[0]);
};